import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder, getHandle } from "../helpers"
import { SkeletonProduct } from "./Skeleton"

export default function Product({ product }) {
    const { format } = useCurrencyFormatting()
    const tags = [
        product.onSale
            ? {
                  label: "Sale",
                  class: "ns-badge ns-badge-green-outline ns-d-inline-block ns-text-align-center"
              }
            : undefined
    ].filter(v => !!v)

    return (
        // <SerpElement
        //     as="product-card"
        //     hit={product}
        //     ariaLabel={`Product ${product.name}`}
        //     class="product-card relative available gap-2 nosto-prod" 
        //     reveal-on-scroll="true" 
        //     handle={getHandle(product.url)} 
        //     style="opacity: 1; transform: translateY(0px);"
        // >
            
        //     <nosto-dynamic-card handle={getHandle(product.url)} template="card" loading>
        //         <SkeletonProduct />
        //     </nosto-dynamic-card>
        // </SerpElement>
        
        <SerpElement
            as="nosto-dynamic-card"
            hit={product}
            ariaLabel={`Product ${product.name}`}
            class="product-card relative available gap-2 nosto-prod" 
            handle={getHandle(product.url)} 
            template="card"
            loading
        >
            <SkeletonProduct />
        </SerpElement>
    )
}
